import DateConverter from "@/models/DateConverter";

export default class ChatMessage
{
	channel = -1
	sender = ""
	senderId : string | null = null

	// Binary timestamp from C#
	timestamp = ""
	text = ""
	messageid = -1

	get datetime() : Date
	{
		return DateConverter.binaryToDate(this.timestamp);
	}
}

export class ChatSendPacketData
{
	channel = -1
	// timestamp field no longer used
	text = ""
}